import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { Site, Entity } from '@debbie/common/dist/index.js';
import { IntentType } from '@debbie/common/dist/intents/index.js';
import { InteractionType, OutgoingState, Direction, } from '@debbie/common/dist/interactions/index.js';
import { UpdateType } from '@debbie/common/dist/updates/index.js';
import { c } from '@debbie/cortex/dist/index.js';
import * as interactions from '@debbie/cortex/dist/api/interactions.js';
import { selectCaseUpdates } from '@debbie/cortex/dist/case/selectors.js';
import { interactionsByReferenceKey } from '@debbie/cortex/dist/interactions/index.js';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors.js';
import { Panel, File, Button, Well, Input, Modal, Intent } from '../index.js';
import OppositionHistory from '../OppositionHistory.js';
import q from '@debbie/cortex/dist/query.js';
const DefaultSummary = (props) => {
    const singleCase = useSelector((s) => props.longCaseId ? selectCaseById(s, props.longCaseId) : null);
    const site = useSelector((s) => s.site);
    const lang = useSelector((s) => s.lang);
    const updates = useSelector((s) => singleCase && selectCaseUpdates(s, singleCase.caseId));
    const [verifying, setVerifying] = useState(false);
    const [oppositionModalOpen, setOppositionModalOpen] = useState(false);
    const [oppositionNote, setOppositionNote] = useState('');
    const oppositions = updates
        ? updates.filter((update) => {
            if (update.refId === props.interaction.id) {
                if ([UpdateType.OPPOSITION, UpdateType.NOTOPPOSITION].includes(update.updateTypeId)) {
                    return true;
                }
            }
            return false;
        })
        : [];
    useEffect(() => {
        if (!singleCase && props.longCaseId) {
            c.cases.getById(props.longCaseId);
        }
    }, [singleCase]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Panel, { id: `interaction-${props.interaction.id}`, style: {
                opacity: props.interaction.state === OutgoingState.PENDING
                    ? typeof props.transparrent === 'boolean'
                        ? props.transparrent
                            ? 0.6
                            : 1
                        : 0.6
                    : 1,
            } },
            React.createElement("div", null, props.children),
            React.createElement("div", null, props.interaction.notes &&
                props.interaction.notes.split('\n').map((item, index) => (React.createElement(React.Fragment, { key: item + index },
                    item,
                    React.createElement("br", null))))),
            props.interaction.direction === Direction.OUTGOING &&
                props.interaction.intent &&
                props.interaction.intent.type !== IntentType.Unknown && (React.createElement("div", { style: { margin: '1em 0 0 0', fontSize: '0.8em' } },
                React.createElement(Intent, { editable: false, intent: props.interaction.intent }))),
            site === Site.Caseworker &&
                (props.interaction.type === InteractionType.Phone ||
                    (props.interaction.direction === Direction.INCOMING &&
                        ![InteractionType.Note, InteractionType.ClientNote].includes(props.interaction.type))) && (React.createElement(OppositionHistory, { interaction: props.interaction, caseId: props.longCaseId, lang: lang }))),
        props.interaction.details &&
            props.interaction.type !== InteractionType.Email &&
            props.interaction.attachments && (React.createElement("div", { style: { marginTop: '-10px' } }, props.interaction.attachments.map((attachment) => (React.createElement(File, { key: attachment.fileId, file: {
                fileName: attachment.fileName,
                fileId: attachment.fileId,
                contentType: attachment.contentType,
            } }))))),
        React.createElement("div", { style: { marginTop: '-10px' } },
            site === Site.Caseworker &&
                props.interaction.state === OutgoingState.PENDING && (React.createElement(Button, { onClick: async () => {
                    setVerifying(!verifying);
                    await interactions.patch(props.interaction.id, {
                        state: OutgoingState.SENT,
                    });
                    if (singleCase) {
                        q.invalidate([
                            interactionsByReferenceKey(Entity.Case, singleCase.caseId),
                        ]);
                    }
                    setVerifying(!verifying);
                }, loading: verifying, size: "small" }, lang.interactions.verify)),
            singleCase &&
                site === Site.Caseworker &&
                (props.interaction.type === InteractionType.Phone ||
                    (props.interaction.direction === Direction.INCOMING &&
                        ![InteractionType.Note, InteractionType.ClientNote].includes(props.interaction.type))) && (React.createElement("div", null,
                React.createElement(Button, { onClick: () => {
                        setOppositionModalOpen(!oppositionModalOpen);
                    }, style: { marginRight: '5px' }, size: "small", theme: oppositions.length ? 'secondary' : undefined },
                    lang.interactions.opposition,
                    "/",
                    lang.interactions.notOpposition),
                oppositionModalOpen && (React.createElement(Modal, { header: lang.interactions.opposition +
                        '/' +
                        lang.interactions.notOpposition, onToggle: () => {
                        setOppositionModalOpen(!oppositionModalOpen);
                    }, maxWidth: "450px" },
                    React.createElement(Well, null,
                        React.createElement(Input, { placeholder: lang.interactions.optionalNote, value: oppositionNote, onChange: (e) => {
                                setOppositionNote(e.target.value);
                            } }),
                        React.createElement(Inline, null,
                            React.createElement(Button, { onClick: async () => {
                                    await c.updates.make({
                                        referenceId: singleCase.caseId,
                                        updateTypeId: UpdateType.OPPOSITION,
                                        update: oppositionNote || null,
                                        remindedAt: moment().format(),
                                        pausedAt: moment().format(),
                                        continuedAt: moment().format(),
                                        refId: props.interaction.id,
                                    });
                                    c.cases.getUpdates(singleCase.caseId);
                                    setOppositionModalOpen(!oppositionModalOpen);
                                } }, lang.interactions.opposition),
                            React.createElement(Button, { onClick: async () => {
                                    await c.updates.make({
                                        referenceId: singleCase.caseId,
                                        updateTypeId: UpdateType.NOTOPPOSITION,
                                        update: oppositionNote || null,
                                        remindedAt: moment().format(),
                                        pausedAt: moment().format(),
                                        continuedAt: moment().format(),
                                        refId: props.interaction.id,
                                    });
                                    c.cases.getUpdates(singleCase.caseId);
                                    setOppositionModalOpen(!oppositionModalOpen);
                                } }, lang.interactions.notOpposition))))))))));
};
export default DefaultSummary;
const Inline = styled.div `
  display: inline-flex;
  width: 100%;
  justify-content: space-between;
`;
//# sourceMappingURL=DefaultSummary.js.map